exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".contentArea p{margin-bottom:calc(.89286vw + 17.14286px)}", ""]);
